import axios from "axios";
import moment from "moment"
import {LOCAL_STORAGE} from '../../utils/constants'
import { DATE_FORMATS } from "../../config/const";

const ReadAxios = async function (props = {}) {
  var gett = LOCAL_STORAGE.userToken
  var customerNo = LOCAL_STORAGE.customerNo
  var userId = LOCAL_STORAGE.userId
  var locales = LOCAL_STORAGE.locales === "en" ? "en-IN" : `pt-BR`

  let congData = JSON.stringify({
    customerNumber: +customerNo,
    userId: userId,
    customer_no: +customerNo,
    user_id: +userId,
    customerNo: +customerNo,
    searchTerm: props.searchTerm,
    ...props.readItems
  });

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    :
    props.FileURL ?
    `${props.FileURL}`
    : props.baseURL ? `${props.baseURL}/${props.url}` : `${process.env.REACT_APP_BASE_URL}/masters/${props.url}`;

  if (props.FileURL) {
    return new Promise((resolve, reject) => {
      var config = {
        method: "get",
        url: apiURL,
        headers: {
          Authorization: `${gett}`,
          "Content-Type": "application/json",
          "Accept-Language": locales,
          "Access-Control-Allow-Origin": "*"
        },
      };

      axios(config)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
  else if (props.completeURL) {
    // try {
    return new Promise((resolve, reject) => {
      var config = {
        method: "get",
        url: apiURL,
        headers: {
          Authorization: `${gett}`,
          "Content-Type": "application/json",
          "Accept-Language": locales,
          "Access-Control-Allow-Origin": "*"
        },
        data: congData,
        params: {
          customer_no: +customerNo,
          user_id: +userId,
          userId: +userId,
          customerNo: +customerNo,
          customerNumber: +customerNo,
          ...props.readItems
        },
      };

      axios(config)
        .then(function (res) {
          if (res.data.status === 200 && res.data.resultSet !== "" && res.data.resultSet) {
            const resultSet = res.data.resultSet.map(rs => {
              try {
                if (rs.hasOwnProperty('createdOn')) {
                  const createdOn = moment(rs.createdOn).isValid() ? moment(rs.createdOn).format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                  rs.createdOn = createdOn
                }
                if (rs.hasOwnProperty('updatedOn')) {
                  const updatedOn = moment(rs.updatedOn).isValid() ? moment(rs.updatedOn).format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                  rs.updatedOn = updatedOn
                }
                rs.updatedBy = rs.updatedBy || "N/A"
              } catch (error) {
                console.log("Date Format Error")
              }
              return rs;
            })
            res.data.resultSet = resultSet
          resolve(res);
        }else{
          resolve(res);
        }
      })
        .catch(function (error) {
          reject(error);
        });
    });
  } else {
    try {
      return new Promise((reslove, reject) => {
        axios
          .post(apiURL, congData, {
            headers: {
              "content-type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales,
              "Access-Control-Allow-Origin": "*"
            },
          })
          .then((res) => {
            if (res.data.status === 200 && res.data.resultSet !== "" && res.data.resultSet) {
              const resultSet = res.data.resultSet.map(rs => {
                try {
                  if (rs.hasOwnProperty('createdOn')) {
                    const createdOn = moment(rs.createdOn).isValid() ? moment(rs.createdOn).format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                    rs.createdOn = createdOn
                  }
                  if (rs.hasOwnProperty('updatedOn')) {
                    const updatedOn = moment(rs.updatedOn).isValid() ? moment(rs.updatedOn).format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                    rs.updatedOn = updatedOn
                  }
                  rs.updatedBy = rs.updatedBy || "N/A"
                } catch (error) {
                  console.log("Date Format Error")
                }
                return rs;
              })
              res.data.resultSet = resultSet
              reslove(res);
            } else {
              if (res.data.permissions) {
                reslove(res);
              } else {
                reslove(res);
              }
            }
          })
          .catch((err) => {
            console.log('err in read', err);
            reject(err);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }
};

export default ReadAxios;
